/* eslint-disable */
import _m0 from "protobufjs/minimal";

export const protobufPackage = "skills";

export interface InitializeGpsActionArgs {
  /** deprecated */
  noArgs: boolean;
  /** If true, we will always succeed after attempting to initialize GPS. */
  alwaysSucceed: boolean;
  /** Set vehicle to return to its original starting position after flying the pattern. */
  returnToStartingPos: boolean;
}

export interface InitializeGpsResultData {
}

export interface InitializeGpsActionStateData {
}

function createBaseInitializeGpsActionArgs(): InitializeGpsActionArgs {
  return { noArgs: false, alwaysSucceed: false, returnToStartingPos: false };
}

export const InitializeGpsActionArgs = {
  encode(message: InitializeGpsActionArgs, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.noArgs === true) {
      writer.uint32(8).bool(message.noArgs);
    }
    if (message.alwaysSucceed === true) {
      writer.uint32(16).bool(message.alwaysSucceed);
    }
    if (message.returnToStartingPos === true) {
      writer.uint32(24).bool(message.returnToStartingPos);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): InitializeGpsActionArgs {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseInitializeGpsActionArgs();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.noArgs = reader.bool();
          continue;
        case 2:
          if (tag !== 16) {
            break;
          }

          message.alwaysSucceed = reader.bool();
          continue;
        case 3:
          if (tag !== 24) {
            break;
          }

          message.returnToStartingPos = reader.bool();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): InitializeGpsActionArgs {
    return {
      noArgs: isSet(object.noArgs) ? globalThis.Boolean(object.noArgs) : false,
      alwaysSucceed: isSet(object.alwaysSucceed) ? globalThis.Boolean(object.alwaysSucceed) : false,
      returnToStartingPos: isSet(object.returnToStartingPos) ? globalThis.Boolean(object.returnToStartingPos) : false,
    };
  },

  toJSON(message: InitializeGpsActionArgs): unknown {
    const obj: any = {};
    if (message.noArgs === true) {
      obj.noArgs = message.noArgs;
    }
    if (message.alwaysSucceed === true) {
      obj.alwaysSucceed = message.alwaysSucceed;
    }
    if (message.returnToStartingPos === true) {
      obj.returnToStartingPos = message.returnToStartingPos;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<InitializeGpsActionArgs>, I>>(base?: I): InitializeGpsActionArgs {
    return InitializeGpsActionArgs.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<InitializeGpsActionArgs>, I>>(object: I): InitializeGpsActionArgs {
    const message = createBaseInitializeGpsActionArgs();
    message.noArgs = object.noArgs ?? false;
    message.alwaysSucceed = object.alwaysSucceed ?? false;
    message.returnToStartingPos = object.returnToStartingPos ?? false;
    return message;
  },
};

function createBaseInitializeGpsResultData(): InitializeGpsResultData {
  return {};
}

export const InitializeGpsResultData = {
  encode(_: InitializeGpsResultData, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): InitializeGpsResultData {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseInitializeGpsResultData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): InitializeGpsResultData {
    return {};
  },

  toJSON(_: InitializeGpsResultData): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<InitializeGpsResultData>, I>>(base?: I): InitializeGpsResultData {
    return InitializeGpsResultData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<InitializeGpsResultData>, I>>(_: I): InitializeGpsResultData {
    const message = createBaseInitializeGpsResultData();
    return message;
  },
};

function createBaseInitializeGpsActionStateData(): InitializeGpsActionStateData {
  return {};
}

export const InitializeGpsActionStateData = {
  encode(_: InitializeGpsActionStateData, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): InitializeGpsActionStateData {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseInitializeGpsActionStateData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): InitializeGpsActionStateData {
    return {};
  },

  toJSON(_: InitializeGpsActionStateData): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<InitializeGpsActionStateData>, I>>(base?: I): InitializeGpsActionStateData {
    return InitializeGpsActionStateData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<InitializeGpsActionStateData>, I>>(_: I): InitializeGpsActionStateData {
    const message = createBaseInitializeGpsActionStateData();
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
